import { useState } from 'react';
import { Box } from '@mui/material';
import { Outlet, useLocation } from 'react-router';
import { TerminalWindow } from './components/TerminalWindow';
import { Taskbar } from './components/Taskbar';
import { BootOverlay } from './components/BootOverlay';
import { CrtOverlay } from '@/layouts/components/CrtOverlay';

export function TerminalDesktop() {
  const loc = useLocation();
  const [isBooted, setIsBooted] = useState(false);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        p: 4,
      }}
    >
      <Box
        sx={{
          width: '100%',
          aspectRatio: '16 / 9',
          border: '2px solid',
          borderColor: 'divider',
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        {/* Desktop background content */}
        <Box sx={{ position: 'absolute', inset: 0 }}>
          <CrtOverlay />
          {!isBooted && <BootOverlay onComplete={() => setIsBooted(true)} />}
          {loc.pathname !== '/' ? (
            <TerminalWindow
              title={loc.pathname.replaceAll('/', '') || 'terminal'}
            >
              <Outlet />
            </TerminalWindow>
          ) : (
            <Outlet />
          )}
        </Box>
        <Taskbar />
      </Box>
    </Box>
  );
}
